<template>
  <!-- 新增社保 -->
  <div class="page_addTemplate">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item><el-breadcrumb-item>信息维护</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/successCaseSet' }">文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>合同模板新增/编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-form :model="formData" :inline="true" ref="tmepForm" label-width="110px">
          <el-form-item label="签约主体" prop="CompanyName">
            <el-select v-model="CompanyName" placeholder="" clearable filterable @change="changeLeg">
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="{label:item.CompanyName,value:item.Id}"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型" prop="BusiType">
            <el-select v-model="formData.BusiType" placeholder="" clearable>
              <el-option v-for="(item,index) in busiList" :key="index" :value="item.strParametername"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同协议类型" prop="ContractProType">
            <el-select v-model="formData.ContractProType" placeholder="" clearable filterable>
              <el-option v-for="(item,index) in agreementList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可签行业" prop="SignTrade">
            <el-cascader ref="industry" :props="propsTree" v-model="CustomerIndustry" :options="treeList" filterable :show-all-levels="false"></el-cascader>
          </el-form-item>
          <el-form-item label="风险类型" prop="RiskType">
            <el-select v-model="formData.RiskType" placeholder="" clearable>
              <el-option label="全风险" value="全风险"></el-option>
              <el-option label="免责" value="免责"></el-option>
              <el-option label="不限" value="不限"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资质管理员" prop="QualificationManager">
            <el-select v-model="formData.QualificationManager" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'QualificationManager','QualificationManagerID')}">
              <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公章管理员" prop="StampKeeper">
            <el-select v-model="formData.StampKeeper" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'StampKeeper','StampKeeperid')}">
              <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同章管理员" prop="ContractSealKeeper">
            <el-select v-model="formData.ContractSealKeeper" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'ContractSealKeeper','ContractSealKeeperid')}">
              <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item label="备注">
              <el-input type="textarea" v-model="formData.Remark" :autosize="{ minRows: 4}"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="模板" prop="ContractUrl">
              <div class="upload_box">
                <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                  <el-button size="small" type="success">上传模板</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div class="btnBox">
            <el-button type="success" @click="submitForm" v-preventReClick>保存</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        formData: {
          Id: '',
          CompanyName: '', //公司名称
          LegalId: '', //主体Id
          BusiType: '', //业务类型
          ContractProType: '', //合同协议类型
          SignTrade: '', //可签行业
          RiskType: '', //风险类型
          QualificationManager: '', //资质管理员
          QualificationManagerID: '',
          StampKeeper: '', //公章管理员
          StampKeeperid: '',
          ContractSealKeeper: '', //合同章管理员
          ContractUrl: '', //模板
          ContractFileName:''
        },
        CompanyName: '',
        legList: [], //主体列表
        //协议下拉列表
        agreementList: ['劳动合同','退休返聘协议','实习协议','兼职协议', '自由职业者服务协议','劳务协议','非全日制用工协议','岗位/业务外包协议','实习生托管协议','生产外包协议','仓储物流外包协议','劳务派遣协议','代理业务协议','代理招聘协议','咨询服务协议','培训服务协议','灵活用工协议'],
        CustomerIndustry: '',
        treeList: [], //行业列表
        fileList: [],
        personnelList: [], //人员列表
        propsTree: {
          label: "strParametername",
          value: "strParametername",
          children: "children",
          checkStrictly: true
        },
        roletype: localStorage.loginRoletype,
        busiList:[],//业务类型列表
      };
    },
    created() {
      if (this.$route.query.row != undefined && this.$route.query.row) {
        this.formData = JSON.parse(this.$route.query.row);
        // console.log(this.formData)
        this.CompanyName = this.formData.CompanyName
        if (this.formData.SignTrade != undefined && this.formData.SignTrade) {
          this.CustomerIndustry = this.formData.SignTrade.split(',')
        }
        if (this.formData.ContractUrl) {
          let item = {
            Id: new Date().valueOf().toString() + Math.random(),
            name: this.formData.ContractUrl,
            url: this.headPath + this.formData.ContractUrl
          }
          this.fileList = [item]
        }
      }
      this.getlegalsubjectlist();
      this.getTreestr('JB_base_Custindust','treeList');
      this.getTreestr('JB_base_Busitype','busiList');
      this.getauthUserInfoByorgancode();
    },
    methods: {
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      getTreestr(type,list) {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: '',
          keyword: ''
        }
        xz.getTreestr(type, data).then(res => {
          if (res) {
            this[list] = res.msg.parent;
          } else {
            this[list] = [];
          }
          this.treeLoading = false;
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      changeLeg(item) {
        this.formData.LegalId = item.value;
        this.formData.CompanyName = item.label;
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.ContractUrl = res;
            this.formData.ContractFileName = file.name;
          }
        });
      },
      handleRemove(file) {
        this.formData.ContractUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 取消
      backHandle() {
        window.close();
        this.$router.push({
          path: "/contractTemplateSet",
        });
      },
      submitForm() {
        this.$refs["tmepForm"].validate((valid) => {
          if (valid) {
            if (!this.isNull(this.CustomerIndustry)) {
              this.formData.SignTrade = this.CustomerIndustry.toString()
            }
            xz.updatecontracttemp(this.formData).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
      //取人员列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = res.msg;
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      //选择人员
      changePerson(val, name, id) {
        this.formData[id] = val.Userid;
        this.formData[name] = val.Username;
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
    cursor: pointer;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 98%;
    display: flex;
    justify-content: center;
  }

  .upload_box {
    width: 300px;
  }
</style>
<style>
  .page_addTemplate .el-input__inner {
    width: 221px;
  }

  .page_addTemplate .el-textarea__inner {
    width: 564px;
  }
</style>